export default "__VITE_ASSET__BYXCY3$F__"